import type { PerimeterTypeWithTag } from '@/contexts/perimeters/Perimeters.interfaces'

export enum AttachmentType {
  PERIMETER = 'Perimeter',
  TAG = 'Tag',
}

export enum PerimeterType {
  PROVIDER = 'PROVIDER',
  APPLICATION = 'APPLICATION',
  INTERNAL = 'INTERNAL',
  OTHER = 'OTHER',
}

export enum OrganizationImportExportAction {
  IMPORT = 'import',
  EXPORT = 'export',
}

export enum OrganizationDatatableColumnId {
  IDENTIFIER = 'identifier',
  NAME = 'name',
  TYPE = 'type',
  PARENTS = 'parents',
  ACTIONS = 'actions',
}

export interface OrganizationTagOption {
  id: number
  name: string
  identifier: string
}

export interface OrganizationNewTree {
  root: true
  tree_parent: null
}

export interface OrganizationCreatedTag {
  id: number
  identifier: string
  name: string | null
  weight?: number | null
  color?: string | null
  edit_right: boolean
  delete_right: boolean
}

export enum OrganizationPerimetersFilterId {
  TYPE = 'type',
  PARENT = 'parent',
}

export interface OrganizationPerimetersFilters {
  parentIds: number[]
  types: PerimeterTypeWithTag[]
}

export interface OrganizationPerimetersFiltersStore {
  customerId: number
  filters: OrganizationPerimetersFilters
}
